export default {
    // SHARED
    black: '#121212',
    blackAlt: '#262626',
    white: '#FFFFFF',
    grey: '#555658',
    greyLight: '#93958F',
    greyVeryLight: '#F2F2F2',
    pending: '#FCE1C0',
    // HTA
    hta: {
        green: '#8FB433',
        greenAlt: '#6F8B27',
        greenDark: '#206142',
        greenLight: '#DCE8BF',
        purple: '#602366',
        tableBg: '#EEF1E9',
    },
    // HTA rebrand
    htaRebrand: {
        green: '#206142',
        greenAlt: '#8FB433',
        greenDark: '#14432C',
        greenLight: '#559677',
        greenLightAlt: '#628D78',
        greenBright: '#66B429',
        greenBg: '#D2DFD9',
        purple: '#602366',
    },
    // APL
    apl: {
        green: '#66BC29',
        greenAlt: '#56A022',
        greenLight: '#BAE19F',
    },
    // HORT HOUSE
    hortHouse: {
        green: '#8FB433',
        greenAlt: '#6F8B27',
        greenDark: '#4D7F42',
        greenLight: '#DCE8BF',
        greyMid: '#747474',
        orange: '#EB7820',
    },
    // RSS
    rss: {
        green: '#95C11F',
        greenDark: '#688816',
        greenLight: '#D1EA8D',
        grey: '#333333',
        greyLight: '#464646',
    },
    validation: {
        error: '#d90000',
        warning: '#e06e1b',
        success: '#56a022',
    },
};
